import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import { Collapse, SvgIcon } from '@mui/material';

import { NEW_FEATURE_DATA_ATTRIBUTE } from 'app/constants';
import { useMenuContext } from 'pages/layout/components/MenuContext';

import useStyles from './styles';

interface Props {
    icon?: React.ComponentType;
    text?: string;
    link?: string;
    itemKey: string;
    indent?: number;
    children: React.ReactNode;
    className?: string;
    onClick?: () => void;
    [NEW_FEATURE_DATA_ATTRIBUTE]?: string;
}

const MenuItem: React.FC<Props> = ({
    icon,
    text,
    link,
    children,
    itemKey,
    indent = 0,
    className,
    onClick,
    ...props
}) => {
    const history = useHistory();
    const { active, expanded } = useMenuContext();

    const { classes, cx } = useStyles({ indent });

    const isExpanded = expanded.includes(itemKey);

    const handleClick = useCallback(
        (event) => {
            event.preventDefault();
            if (link) {
                link.startsWith('https') ? window.open(link, '_blank') : history.push(link);
            }
            onClick?.();
        },
        [history, link, onClick]
    );

    return (
        <>
            <a
                href={link}
                className={cx(
                    classes.root,
                    {
                        [classes._active]: itemKey === active,
                        [classes._expanded]: isExpanded
                    },
                    className
                )}
                onClick={handleClick}
                {...{ [NEW_FEATURE_DATA_ATTRIBUTE]: props[NEW_FEATURE_DATA_ATTRIBUTE] }}
            >
                <span data-role="spacer" className={classes.spacer} />
                {icon ? <SvgIcon className={classes.icon} component={icon} /> : null}
                <span className={classes.text}>{text}</span>
            </a>
            {children && <Collapse in={isExpanded}>{children}</Collapse>}
        </>
    );
};

export default MenuItem;
